import { infiniteQueryOptions } from '@tanstack/react-query'
import { PurchaseHistoryQuery } from '@/features/shop/services/Search/constants'
import { type SearchParams } from '@/features/shop/services/Search/types'
import { type StoreParamsAsKey } from '@/features/shared/utils/dataFetching/storeParams'
import { fetchPurchaseHistory } from '@/features/shop/services/Search/fetchers'

export const infinitePurchaseHistoryQueryOptions = (
  params: StoreParamsAsKey & { params: SearchParams },
) =>
  infiniteQueryOptions({
    queryKey: [PurchaseHistoryQuery, params] as const,
    queryFn: fetchPurchaseHistory,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { total_hits, page, hits_per_page } = lastPage
      if (total_hits - page * hits_per_page <= 0) return undefined
      return page + 1
    },
    placeholderData: (previousData) => previousData,
  })
